/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPagination
 */
export interface APIPagination {
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    total_count: number;
}

/**
 * Check if a given object implements the APIPagination interface.
 */
export function instanceOfAPIPagination(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "offset" in value;
    isInstance = isInstance && "total_count" in value;

    return isInstance;
}

export function APIPaginationFromJSON(json: any): APIPagination {
    return APIPaginationFromJSONTyped(json, false);
}

export function APIPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'offset': json['offset'],
        'total_count': json['total_count'],
    };
}

export function APIPaginationToJSON(value?: APIPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'offset': value.offset,
        'total_count': value.total_count,
    };
}

